export function isValidHexCode(str: string) {
  const regex = new RegExp(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)
  return str !== null && regex.test(str)
}